import { render } from "./syarat-berperkara.vue?vue&type=template&id=5982bd9a&scoped=true"
import script from "./syarat-berperkara.vue?vue&type=script&lang=js"
export * from "./syarat-berperkara.vue?vue&type=script&lang=js"

import "./syarat-berperkara.vue?vue&type=style&index=0&id=5982bd9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5982bd9a"

export default script